import { render, staticRenderFns } from "./NavMenuStart.vue?vue&type=template&id=048cc718"
import script from "./NavMenuStart.vue?vue&type=script&lang=js"
export * from "./NavMenuStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports